import { render, staticRenderFns } from "./SalesStatus.vue?vue&type=template&id=31203126&scoped=true"
import script from "./SalesStatus.vue?vue&type=script&lang=js"
export * from "./SalesStatus.vue?vue&type=script&lang=js"
import style0 from "./SalesStatus.vue?vue&type=style&index=0&id=31203126&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31203126",
  null
  
)

export default component.exports